import { Injectable } from '@angular/core';
import { format } from 'date-fns';

@Injectable({ providedIn: 'root' })
export class DateUtilsService {
  timeStampToDate(date: string | Date | undefined, formatTime: string) {
    if (!date) return;

    const _date = new Date(date.toString());
    if (formatTime === 'intl') {
      return new Intl.DateTimeFormat('id', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'Asia/Jakarta',
      }).format(_date);
    }

    return format(_date, formatTime);
  }

  dateStringToEpoch(date: string): number {
    return Date.parse(date) * 1000;
  }

  formatEpochToDate(epoch: number, fmt: string = 'dd-MM-yyyy'): string {
    if (!epoch) return '';
    const date = new Date(epoch);

    if (fmt === 'intl') {
      return new Intl.DateTimeFormat('id', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'Asia/Jakarta',
      }).format(date);
    }

    return format(date, fmt);
  }

  formatEpochTime(epoch: number, needPlus7 = false): string {
    const date = new Date(epoch);
    if (needPlus7) date.setTime(date.getTime() + 7 * 60 * 60 * 1000);
    return new Intl.DateTimeFormat('en', {
      timeZone: 'Asia/Jakarta',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hourCycle: 'h24',
    }).format(date);
  }

  countDays(start: Date, end: Date): number {
    const ms = end.getTime() - start.getTime();
    return Math.floor(ms / (1000 * 60 * 60 * 24)) + 1;
  }

  formatStringToIntlId(dateString: string, withTime: boolean = false, useIntlFormat: boolean = true) {
    if (!dateString) return '';

    // Handle both comma and space as separator between date and time
    // Remove comma and extra spaces, then split by space
    const cleanedString = dateString.replace(/,\s*/g, ' ').trim();
    const [datePart, timePart] = cleanedString.split(' ');
    const [day, month, year] = datePart.split('-');

    // Create date object
    const date = new Date(`${year}-${month}-${day}${timePart ? `T${timePart}` : ''}`);

    // Check if date is valid
    if (isNaN(date.getTime())) return '-';

    let formattedDate: string;
    if (useIntlFormat) {
      const dateOptions: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'Asia/Jakarta',
      };
      formattedDate = new Intl.DateTimeFormat('id', dateOptions).format(date);
    } else {
      // Use dd-MM-yyyy format
      formattedDate = datePart;
    }

    // Add time if requested
    if (withTime && timePart) {
      return `${formattedDate}, ${timePart}`;
    }

    return formattedDate;
  }

  calculateDateDiff(date: string): number {
    const today = new Date();
    const d = new Date(date);
    return Math.floor((Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) - Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())) / (1000 * 60 * 60 * 24));
  }
}
